import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const ResourceListTabs = ({ tabs, activeTab, listParam = 'tab' }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleChange = (tabId) => {
    const next = new URLSearchParams(searchParams);
    if (tabId === tabs[0]?.id) {
      next.delete(listParam);
    } else {
      next.set(listParam, tabId);
    }
    setSearchParams(next, { replace: true });
  };

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: 52,
        mt: 2.5,
        mb: 2,
        px: { xs: 1, sm: 0 },
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'stretch',
          border: '1px solid #cbd5e1',
          borderRadius: 0,
          backgroundColor: '#eef2f6',
        }}
      >
        {tabs.map((tab, index) => {
          const selected = activeTab === tab.id;
          const badgeCount = tab.badge || 0;

          return (
            <Box
              key={tab.id}
              component="button"
              type="button"
              onClick={() => handleChange(tab.id)}
              sx={{
                appearance: 'none',
                border: 'none',
                borderRight:
                  index < tabs.length - 1 ? '1px solid #cbd5e1' : 'none',
                backgroundColor: selected ? '#ffffff' : 'transparent',
                color: selected ? '#0F2137' : '#64748b',
                px: 3,
                py: 1.35,
                minHeight: 44,
                minWidth: 132,
                cursor: 'pointer',
                fontWeight: selected ? 700 : 500,
                fontSize: '13px',
                fontFamily: 'inherit',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                borderRadius: 0,
                boxShadow: selected ? 'inset 0 3px 0 #0F2137' : 'none',
                transition: 'background-color 0.15s ease, color 0.15s ease',
                '&:hover': {
                  backgroundColor: selected ? '#ffffff' : '#e4eaf0',
                  color: '#0F2137',
                },
              }}
            >
              <Typography
                component="span"
                sx={{
                  fontSize: 'inherit',
                  fontWeight: 'inherit',
                  lineHeight: 1.2,
                }}
              >
                {tab.label}
              </Typography>
              {badgeCount > 0 ? (
                <Box
                  component="span"
                  sx={{
                    minWidth: 20,
                    height: 20,
                    px: 0.5,
                    borderRadius: 0,
                    backgroundColor: '#dc2626',
                    color: '#fff',
                    fontSize: '11px',
                    fontWeight: 700,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1,
                  }}
                >
                  {badgeCount > 99 ? '99+' : badgeCount}
                </Box>
              ) : null}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default ResourceListTabs;
